const steps = [
  'Sobre o cliente',
  'Sobre o dispositivo',
  'Mais sobre o cliente',
  'Pagamento',
  'Ordem de Serviço',
];

export default steps;
